// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"515d7a2a","818":"c723bde8","948":"a45769cb"}[chunkId] + ".chunk.js";
};